import React, { useState } from 'react'
import useTrans from '@hooks/useTrans'
import { cn, dateChatFormat } from '@utils/safeTs'
import { MessaggioChatType, RootStateType } from '@utils/types'
import { Attachment, Bin } from '@components/icons'
import { Avatar, ChatAttachment } from '@components/atoms'
import styles from './ChatMessage.module.sass'
import { useSelector } from 'react-redux'

export interface ChatMessageProps {
  item: MessaggioChatType
  onRemove?: () => void
  className?: string
}

export default function ChatMessage({ item, onRemove, className }: ChatMessageProps) {

  const t = useTrans()
  const { utente } = useSelector((state: RootStateType) => state.utente)
  
  return (
    <article className={cn(styles.root, className)} role="listitem">
      <div className={styles.head}>
        <div className={styles.details}>
          <span className={styles.data}>{dateChatFormat(item.created, t)}</span>
          {item.utente?.id === utente?.id && (
            <button type="button" onClick={onRemove} className={styles.remove}>
              <Bin />
            </button>
          )}
        </div>
        <div className={styles.identity}>
          <Avatar id={`chatmessage_${item.id}_avatar`} showTooltip={false} utente={item.utente} variant='chat' />
          <div className={styles.identityText}>
            {(!!item.utente?.nome || !!item.utente?.cognome) && <span className={styles.name}>{item.utente?.nome} {item.utente?.cognome}</span>}
            {!!item.utente?.anagraficaAzienda?.ragioneSociale && (
              <span className={styles.company}>{item.utente.anagraficaAzienda?.ragioneSociale}</span>
            )}
          </div>
        </div>
      </div>
      <div className={styles.body}>
        <p className={styles.message}>{item.messaggio}</p>
        {item.allegati?.length ? (
          <ul className={styles.attachments}>
            {item.allegati.map((attachment) => (
              <li key={attachment.id} className={styles.attachment}>
                <ChatAttachment attachment={attachment} />
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </article>
  )
}
